export class SalonCategories {
  constructor() {
    this.SalonServices = document.querySelectorAll(".js-salon-categories");
    this.initServices();
  }

  initServices() {
    if (this.SalonServices){
      this.SalonServices.forEach(SalonService => {
        const buttons = SalonService.querySelectorAll(".js-menu-button");

        if (buttons.length > 0) {
          buttons[buttons.length - 1].classList.add("SalonCategories--border");
        }

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const category = button.dataset.category;
            const card = SalonService.querySelector(
              `.js-category[data-category="${category}"]`
            );

            if (card) {
              card.classList.toggle("hidden");

              if (card.classList.contains("hidden")) {
                button.classList.remove("SalonCategories--active");
              } else {
                button.classList.add("SalonCategories--active");
              }
            }
          });
        });
      });
    }
  }
}
